import styled from "@emotion/styled";

import { BasicFlex } from "../../../utils/Common";

import { formatCurrency } from "../../../utils/util";

import MultiStatusChip from "../../../utils/utilities/MultiStatusChip";

const BalanceAmount = styled.div`
  font-weight: ${props => props.$total ? '600' : '500'};
  font-size: ${props => props.$total ? '1.6rem' : '1.4rem'};
  color: ${props => props.$balance ? props.theme.colors.error : "inherit"};
  opacity: ${props => props.$muted ? 0.6 : 1};
`

const BalanceDisplay = ({ balance }) => {
  let value = balance === 0 ? 'settled' : balance > 0 ? 'due' : 'credit';
  let formatted = Math.abs(balance);

  return (
  <BasicFlex justify="flex-end" gap=".6rem" width="auto"> 
  <BalanceAmount>{formatCurrency(formatted)}</BalanceAmount> 
  <MultiStatusChip value={value} values={[{value: "settled", label: "Settled", status: "basic"}, {value: "due", label: "Due", status: "error"}, {value: "credit", label: "Credit", status: "success"}]} br="10px" py=".2rem" fs="1.2rem" />
  </BasicFlex>
)
};

export default BalanceDisplay